<template>
  <div style="height:100%">

    <el-row>
      <el-col :span="3" class="title">
        <!-- <el-image
          style="width: 130px; height: 61px"
          src="../../static/Logo_WG.png"
          fit="scale-down"></el-image> -->
          <el-image style="width: 130px; height: 37px;" src="../../static/Logo_WG.png" fit="scale-down"></el-image>
          <div style="color:lightblue;font-size:14px;">游戏联运商户数据管理系统</div>
      </el-col>
      <el-col :span="18">
        <el-menu :default-active="activeIndex" mode="horizontal" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" @select="handleTopMenuSelect">
          <el-menu-item index="/mer_home">商户管理</el-menu-item>
          <el-menu-item index="/mer_apply">应用管理</el-menu-item>
          <el-menu-item index="/mer_order">订单管理</el-menu-item>
          <!-- <el-menu-item index="/mer_thoroug">账务管理</el-menu-item> -->
          <el-menu-item index="/mer_data">数据分析</el-menu-item>
          <!-- <el-menu-item index="/mer_market">营销管理</el-menu-item> -->
            <!-- 技术支持跳转按钮 -->
          <el-menu-item @click.native="goToMerchant">
            <i class="el-icon-s-platform" style="margin-right: 5px;"></i>技术支持
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="3" class="exit">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link" style="color:#fff;font-size: 16px;">
            <el-link :underline="false" type="success">{{this.$store.state.userInfo.username}}</el-link>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">修改密码</el-dropdown-item>
            <el-dropdown-item command="b">个人详情</el-dropdown-item>
            <el-dropdown-item command="c">退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="3" style="background-color:#545c64" class="drawer_body_100">
        <el-menu router :default-active="$route.path" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" ref="leftNavigation" :key="currentTopRoute" v-show="showLeftMenu">
          <template v-for="(issue,index) in $router.options.routes">
            <template v-if="issue.path === currentTopRoute && issue.children">
              <template v-for="(item,index) in issue.children">

                <el-menu-item :index="item.path">
                  {{item.name}}
                </el-menu-item>
              </template>
            </template>
          </template>
        </el-menu>
      </el-col>
      <el-col :span="21" class="drawer_body_100">
          <router-view/>
      </el-col>
    </el-row>

    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="passFrom" size="mini" :rules="passFromRules" ref="passFrom">
        <el-form-item label="原密码" label-width="120px" prop="lpassword">
          <el-input v-model="passFrom.lpassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="120px" prop="newlpassword">
          <el-input v-model="passFrom.newlpassword" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      list:[],
      activeIndex: '/mer_home',
      menu:[],
      dialogFormVisible:false,
      showLeftMenu: true, // 控制左侧菜单的显示
      passFrom:{
        lpassword:'',
        newlpassword:''
      },
      passFromRules:{
        lpassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newlpassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: this.validatePassword, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    // 当前顶部菜单对应的路由
    currentTopRoute() {
      return this.activeIndex;
    }
  },
  created(){
    this.fetchNavData();
    this.search();
  },
  mounted() {
    // console.log(this.$refs.leftNavigation);
    // this.$refs.leftNavigation.open("/user");
  },
  methods: {
    // 密码验证函数
    validatePassword(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入新密码'));
        return;
      }
      
      // 检查长度
      if (value.length < 8 || value.length > 30) {
        callback(new Error('密码长度为8-30位'));
        return;
      }
      
      // 检查是否包含至少三种字符类型（数字、小写字母、大写字母、特殊符号）
      const hasLower = /[a-z]/.test(value);
      const hasUpper = /[A-Z]/.test(value);
      const hasDigit = /\d/.test(value);
      const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value);
      
      const typeCount = [hasLower, hasUpper, hasDigit, hasSpecial].filter(Boolean).length;
      if (typeCount < 3) {
        callback(new Error('密码必须包含数字、大小写字母、特殊符号中的至少三种'));
        return;
      }
      
      // 检查是否有连续重复字符（3个或以上相同字符）
      if (/(.)\1{2,}/.test(value)) {
        callback(new Error('密码不能包含连续重复的字符（如aaa、333）'));
        return;
      }
      
      // 检查是否有连续的数字或字母（3个或以上）
      if (/(?:012|123|234|345|456|567|678|789|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|ABC|BCD|CDE|DEF|EFG|FGH|GHI|HIJ|IJK|JKL|KLM|LMN|MNO|NOP|OPQ|PQR|QRS|RST|STU|TUV|UVW|VWX|WXY|XYZ)/i.test(value)) {
        callback(new Error('密码不能包含连续的数字或字母（如123、abc）'));
        return;
      }
      
      // 检查是否有倒序连续字符（3个或以上）
      if (/(?:210|321|432|543|654|765|876|987|cba|dcb|edc|fed|gfe|hgf|ihg|jih|kji|lkj|mlk|nml|onm|pon|qpo|rqp|srq|trs|uts|vut|wvu|xwv|yxw|zyx|CBA|DCB|EDC|FED|GFE|HGF|IHG|JIH|KJI|LKJ|MLK|NML|ONM|PON|QPO|RQP|SRQ|TSR|UTS|VUT|WVU|XWV|YXW|ZYX)/i.test(value)) {
        callback(new Error('密码不能包含倒序连续的字符（如321、cba）'));
        return;
      }
      
      // 检查是否全是数字
      if (/^\d+$/.test(value)) {
        callback(new Error('密码不能全是数字'));
        return;
      }
      
      // 检查是否全是字母
      if (/^[a-zA-Z]+$/.test(value)) {
        callback(new Error('密码不能全是字母'));
        return;
      }
      
      callback();
    },
    goToMerchant() {
      window.open('https://siapcn-platfrom.local.opentide.com.cn', '_blank');
    },
    search(){
      let info = this.$store.state.userInfo;
      let _this = this;
      this.$ajax({
        url:"coupon-system/site/mer/list",
        async:false,
        data: {'state':'0','merchNo':info.userbh},
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            let list = response.data.content || [];
            _this.list = list;
            if (list.length > 0) {
              for (var i = 0; i < list.length; i++) {
                _this.showTip(list[i])
              }
            }
          }
        }
      })
    },
    showTip(item){
      this.$confirm(item.title, '站内公告', {
        distinguishCancelAndClose: true,
        confirmButtonText: '标记已读',
        cancelButtonText: '前往查看'
      }).then(() => {
          this.readState(item);
      }).catch(action => {
        this.$router.push({path:"/mer_home/site"});
      });
    },
    readState(row){
      this.$ajax({
        url:"coupon-system/site/upd",
        async:false,
        data:{ 'id':row.siteId },
        token:window.sessionStorage.getItem('token')
      })
    },
    fetchNavData () { // 初始化菜单激活项
      var that = this;
      var cur_path = this.$route.path; //获取当前路由
      var routers = this.$router.options.routes; // 获取路由对象
      var nav_type = "", nav_name = "", nav_path = "";

      // 根据当前路由更新顶部菜单的 activeIndex
      var newActiveIndex = '/mer_home';
      if (cur_path.startsWith('/mer_home')) {
        newActiveIndex = '/mer_home';
      } else if (cur_path.startsWith('/mer_apply')) {
        newActiveIndex = '/mer_apply';
      } else if (cur_path.startsWith('/mer_order')) {
        newActiveIndex = '/mer_order';
      } else if (cur_path.startsWith('/mer_data')) {
        newActiveIndex = '/mer_data';
      }
      this.activeIndex = newActiveIndex;

      // 显示左侧菜单
      this.showLeftMenu = true;

      // 使用 $nextTick 确保 DOM 更新后再更新左侧菜单
      this.$nextTick(() => {
        for (var i = 0; i < routers.length; i++) {
          var children = routers[i].children;

          if(children && children.length > 0){
            for(var k = 0; k < children.length; k++){
              var children2 = children[k].children;

              if(children2 && children2.length > 0){
                for(var j = 0; j < children2.length; j++){
                  if(children2[j].path === cur_path) {
                    nav_name = routers[i].name;
                    nav_path = routers[i].path;
                    break;
                  }
                }
              }
              if(children[k].path === cur_path) {
                nav_name = routers[i].name;
                nav_path = routers[i].path;
                break;
              }
            }
          }
          if(routers[i].path === cur_path) {
            nav_name = routers[i].name;
            nav_path = routers[i].path;
            break;
          }
        }
        // this.$store.state.topNavState = nav_type;  // 改变topNavState状态的值
        this.$store.state.topNavPath = nav_path;  // 改变topNavState状态的值
        this.$store.state.leftNavState = nav_name;  // 改变leftNavState状态的值
        if(nav_type == "merchhome"){
          this.defaultActiveIndex = "/";
        } else {
          this.defaultActiveIndex = "/" + nav_name + "Manager";
        }
      });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleTopMenuSelect(index, indexPath) {
      // 如果点击的是技术支持，不处理路由跳转
      if (!index) return;

      // 隐藏左侧菜单，避免闪烁
      this.showLeftMenu = false;

      // 跳转到对应的路由，路由变化会触发 fetchNavData 更新 activeIndex
      this.$router.push({path: index});
    },
    handleExit(){
      this.$confirm('确认退出？')
          .then(_ => {
            let that = this;
            this.$ajax({
              url:"merch/logout",
              async:false,
              methods:'POST',
              token:window.sessionStorage.getItem('token'),
              success:function(response){
                window.sessionStorage.clear();
                that.$router.push({path:"/merch/login"});
              },
              error:function(){
                // 即使接口调用失败，也清除本地存储并跳转
                window.sessionStorage.clear();
                that.$router.push({path:"/merch/login"});
              }
            })
            window.sessionStorage.clear();
            this.$router.replace({path:"/merch/login"});
          })
    },
    handleCommand(command) {
      if (command == "a") {
        this.dialogFormVisible = true;
      }else if (command == "b") {
        this.$router.push({path:"/mer_home/minfo"});
      }else if (command == "c") {
        this.handleExit();
      }
    },
    submitForm() {
      let that = this;
      
      // 检查原密码和新密码是否相同
      if (this.passFrom.lpassword === this.passFrom.newlpassword) {
        this.$message.error('新密码不能与原密码相同');
        return;
      }
      
      this.$refs.passFrom.validate((valid) => {
        if (valid) {
          let info = that.$store.state.userInfo;
          that.passFrom.merchno=info.userbh;
          that.$ajax({
            url:"coupon-merch/merch/updPassword",
            async:false,
            data:that.passFrom,
            methods:'POST',
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code== 0) {
                that.$message(response.data);
                that.dialogFormVisible = false;
                that.$refs.passFrom.resetFields();
              }else{
                that.$message.error('修改失败');
              }
            },
            error:function(){
              that.$message.error('请求失败');
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  watch: {
    '$route': 'fetchNavData'  //监听router值改变时，改变导航菜单激活项
  }
}
</script>

<style scoped>
.title{
  /* height: 100%; */
  background-color: #545c64;
  /* color:#fff; */
  text-align: center;
  /* line-height: 61px; */
  /* font-size: 30px; */
}

.exit{
  height: 60px;
  background-color: #545c64;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #fff
}

.el-header, .el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  height: 100%;
  /* line-height: 160px; */
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/merch/home.vue